module.exports = __webpack_public_path__ + "static/media/JulianWanWNoLnJo7tS8Unsplash.87e51d21.jpg";